import { inject, Injectable } from '@angular/core';

import { ElectronServiceBus } from '@spaces-ui/electron-service-bus';

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private electronServiceBus = inject(ElectronServiceBus);

  public constructor() {
    window.addEventListener('error', errorEvt => {
      this.error(errorEvt.message);
    });
  }

  public debug(...message: unknown[]): void {
    console.debug(...message);
    this.electronServiceBus.logDebug(...message);
  }

  public info(...message: unknown[]): void {
    console.info(...message);
    this.electronServiceBus.logInfo(...message);
  }

  public warn(...message: unknown[]): void {
    console.warn(...message);
    this.electronServiceBus.logWarn(...message);
  }

  public error(...message: unknown[]): void {
    console.error(...message);
    this.electronServiceBus.logError(...message);
  }
}
